import React from "react";
import "./InformationGeneral.scss"
import MediaEditor from "../../../../components/upload/components/MediaEditor/MediaEditor";

const InformationGeneral = ({
        mediaId = null,
        legend = "",
        mentions = [],
        links = [],
        kind = "gallery",
        updatedAt = null,
        handleUpdateContent = ()=>{}
    }) => {



    function onChangeText(editState){
        handleUpdateContent(editState)
    }


    return (
        <div id={"information-general"} key={updatedAt}>
            {kind === "video" ? <div className={"information-general-info"}>ASTUCE : Une fois votre vidéo encodée, vous pouvez modifier sa vignette en allant l'éditer.</div> : null }
            <div className={"information-general-form"}>
                {legend.length === 0 ?<div className={"error-text"}>Choisissez une légende qui décrit votre publication.</div> : null}
                <MediaEditor
                    mentions={mentions || []}
                    links={links || []}
                    text={legend}
                    onChange={(editorState) => onChangeText(editorState)}
                />
            </div>

        </div>
    )
}

export default InformationGeneral;